.ul {
    composes: listReset from "../../styles/composable/utility.module.css";
}

.li {
    display: flex;
    gap: var(--spacer-12);
    margin-top: var(--spacer-12);
    font: var(--font-p-14);
    line-height: 1.3;
}

.clickable {
    &:hover {
        color: var(--red);
    }

    span {
        display: block;
    }
}

.heading {
    composes: fontUppercase from "../../styles/composable/typography.module.css";
    font: var(--font-eyebrow);
}

.heart {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    fill: var(--black);
    translate: 0 2px;
}

.heartFilled {
    composes: heart;
    fill: var(--red);
}
